/**
 * @ngdoc filter
 * @name cfn.convertArea
 * @description
 * # convertArea
 * Converts area from DB units to user defined one
 */
angular
  .module('cfn')
  .filter('convertArea', [
    'unitConverter',
    'userSettingsService',
    '$filter',
    convertArea
  ]);

function convertArea(unitConverter, userSettingsService, $filter) {
  /**
   * @param {number} value value to be converted (if it's not a number it will be returned as is)
   */
  return function(value, decimals) {
    if (_.isNumber(value)) {
      var userAreaUnit = userSettingsService.getAreaUnitEnum();
      if (!_.isNumber(decimals)) {
        decimals = unitConverter.unitDefaultDecimals(userAreaUnit);
      }
      return $filter('number')(
        unitConverter.convert(
          'AREAL_HA',
          userSettingsService.getAreaUnitEnum(),
          value
        ),
        decimals
      );
    }

    return value;
  };
}

export default convertArea;
